import { render, staticRenderFns } from "./ProductStatistics.vue?vue&type=template&id=60159c4b&"
import script from "./ProductStatistics.vue?vue&type=script&lang=js&"
export * from "./ProductStatistics.vue?vue&type=script&lang=js&"
import style0 from "./ProductStatistics.vue?vue&type=style&index=0&id=60159c4b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports